<template>
  <div>
    <div class="context__mobile">
      <Dropdown
        :options="contexts"
        :handleSelection="dropdownHandler"
        :placeholder="currentContext"
      ></Dropdown>
    </div>
    <div class="context">
      <div class="context__wrapper">
        <div class="context__choices-wrapper">
          <button
            v-for="(context, i) in contexts"
            :key="`search-context-${i}`"
            :class="[
              'context__choice',
              currentContext === context && 'context__chosen',
              itemsLength[context] === 0 && 'context__disabled',
            ]"
            @click="updateContext(context)"
          >
            {{ context }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Dropdown from '@/components/forms/elements/Dropdown.vue'

export default {
  name: 'Context',
  components: {
    Dropdown,
  },
  props: {
    contexts: {
      type: Array,
      required: true,
    },
    currentContext: {
      type: String,
      required: true,
    },
    itemsLength: {
      type: Object,
      required: true,
    },
  },
  methods: {
    updateContext(context) {
      this.$emit('update-context', context)
    },
    dropdownHandler(e) {
      this.updateContext(e)
    },
  },
}
</script>

<style lang="scss" scoped>
.context {
  width: 100%;
  display: none;

  @include mobile {
    display: inherit;
  }
  &__wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__choices-wrapper {
    width: 100%;
    display: block;
    @include mobile {
      display: flex;
    }
  }
  &__choice {
    border-radius: 40px;
    white-space: nowrap;
    background: transparent;
    color: var(--white);
    margin: 0 5px 0 0;
    transition: 0.5s all ease;
    border: none;
    padding: 10px 15px;
    font-size: 1rem;
    margin: 0 30px 0 0;
    text-transform: capitalize;
    &:hover {
      cursor: pointer;
      background: var(--white);
      box-shadow: var(--white-light-box-shadow);
      color: var(--charcoal);
    }
    &:active {
      color: var(--charcoal);
      background: var(--athens-gray);
    }
  }
  &__chosen {
    background: var(--white);
    color: var(--charcoal);
  }
  &__disabled {
    opacity: 0.3;
    pointer-events: none;
  }

  &__mobile {
    @include mobile {
      display: none;
    }
  }
}
</style>
